import i18n from '../i18n';

export const UNDERAGE_VALUE = 18;

export const dateStringFormat = 'yyyy-MM-dd';

// employee types
export const FULLTIME = 'fullTime';
export const CONTRACT = 'contract';
export const FREELANCE = 'freelance';

// availability types
export const AD_LABEL = 'AD';
export const AM_LABEL = 'AM';
export const PM_LABEL = 'PM';
export const NA_LABEL = 'NA';

// availability status
export const BOOKED_AD = 'booked-AD';
export const BOOKED_AM_UNAVAILABLE_PM = 'booked-AM-unavailable-PM';
export const BOOKED_PM_UNAVAILABLE_AM = 'booked-PM-unavailable-AM';
export const BOOKED_AM_AVAILABLE_PM = 'booked-AM-available-PM';
export const BOOKED_PM_AVAILABLE_AM = 'booked-PM-available-AM';
export const BOOKED_DECLINED = 'booked-declined';
export const UNAVAILABLE_AD = 'unavailable-AD';
export const AVAILABLE_AD = 'available-AD';
export const AVAILABLE_AM = 'available-AM';
export const AVAILABLE_PM = 'available-PM';

export const availabilityStatusTable = {
  [BOOKED_AD]: {
    statusText: i18n.t('availability:bookedAD'),
    styleClass: 'availEmployeeChipBooked'
  },
  [BOOKED_AM_UNAVAILABLE_PM]: {
    statusText: i18n.t('availability:bookedAMunavailablePM'),
    styleClass: 'availEmployeeChipBookedAMunavailPM',
  },
  [BOOKED_PM_UNAVAILABLE_AM]: {
    statusText: i18n.t('availability:bookedPMunavailableAM'),
    styleClass: 'availEmployeeChipBookedPMunavailAM',
  },
  [BOOKED_AM_AVAILABLE_PM]: {
    statusText: i18n.t('availability:bookedAMavailablePM'),
    styleClass: 'availEmployeeChipBookedAMavailPM',
  },
  [BOOKED_PM_AVAILABLE_AM]: {
    statusText: i18n.t('availability:bookedPMavailableAM'),
    styleClass: 'availEmployeeChipBookedPMavailAM',
  },
  [BOOKED_DECLINED]: {
    statusText: i18n.t('availability:bookedDeclined'),
    styleClass: 'availEmployeeChipBookedDeclined',
  },
  [UNAVAILABLE_AD]: {
    statusText: i18n.t('availability:unavailableAD'),
    styleClass: 'availEmployeeChipUnavailable',
  },
  [AVAILABLE_AD]: {
    statusText: i18n.t('availability:availableAD'),
    styleClass: 'availEmployeeChipAvailableAD',
  },
  [AVAILABLE_AM]: {
    statusText: i18n.t('availability:availableAM'),
    styleClass: 'availEmployeeChipAvailableAM',
  },
  [AVAILABLE_PM]: {
    statusText: i18n.t('availability:availablePM'),
    styleClass: 'availEmployeeChipAvailablePM',
  },
};

// employee notes
export const MAX_NOTE_CHARS = 7500;

// calendar
export const days = [
  i18n.t('availability:sunday'),
  i18n.t('availability:monday'),
  i18n.t('availability:tuesday'),
  i18n.t('availability:wednesday'),
  i18n.t('availability:thursday'),
  i18n.t('availability:friday'),
  i18n.t('availability:saturday'),
  i18n.t('availability:sunday')
];

export const months = [
  i18n.t('availability:january'),
  i18n.t('availability:february'),
  i18n.t('availability:march'),
  i18n.t('availability:april'),
  i18n.t('availability:may'),
  i18n.t('availability:june'),
  i18n.t('availability:july'),
  i18n.t('availability:august'),
  i18n.t('availability:september'),
  i18n.t('availability:october'),
  i18n.t('availability:november'),
  i18n.t('availability:december')
];

export const monthItems = [
  {
    value: 0,
    displayValue: i18n.t('availability:january')
  },
  {
    value: 1,
    displayValue: i18n.t('availability:february')
  },
  {
    value: 2,
    displayValue: i18n.t('availability:march')
  },
  {
    value: 3,
    displayValue: i18n.t('availability:april')
  },
  {
    value: 4,
    displayValue: i18n.t('availability:may')
  },
  {
    value: 5,
    displayValue: i18n.t('availability:june')
  },
  {
    value: 6,
    displayValue: i18n.t('availability:july')
  },
  {
    value: 7,
    displayValue: i18n.t('availability:august')
  },
  {
    value: 8,
    displayValue: i18n.t('availability:september')
  },
  {
    value: 9,
    displayValue: i18n.t('availability:october')
  },
  {
    value: 10,
    displayValue: i18n.t('availability:november')
  },
  {
    value: 11,
    displayValue: i18n.t('availability:december')
  }
];

// retouch multipliers used to determine number of photos per item
export const RETOUCH_RTW_MULTIPLIER = 1;
export const RETOUCH_MFL_MULTIPLIER = 1;
export const RETOUCH_OMACC_MULTIPLIER = 1;

// location type : daily assignment map
export const locationAssignmentMap = {
  'STUDIO': 'studiodailyassignments',
  'SET': 'accessorydailyassignments',
  'PREP': 'prepdailyassignments',
  'ACCESSORY PREP': 'accessoryprepdailyassignments',
};

// gender
export const MALE = 'male';
export const FEMALE = 'female';

// options

export const genderOptions = [
  { value: MALE, displayValue: i18n.t('menswear').toUpperCase() },
  { value: FEMALE, displayValue: i18n.t('womenswear').toUpperCase() }
];

export const accSetTypeOptions = [
  { value: 'regular', displayValue: i18n.t('location:regular').toUpperCase() },
  { value: 'jewelry', displayValue: i18n.t('location:jewelry').toUpperCase() },
  { value: 'special', displayValue: i18n.t('location:special').toUpperCase() }
];

export const studioBeautyTypeOptions = [
  { value: 'regular', displayValue: i18n.t('location:regular').toUpperCase() },
  {
    value: 'new + direction',
    displayValue: i18n.t('location:new + direction').toUpperCase()
  },
  {
    value: 'direction',
    displayValue: i18n.t('location:direction').toUpperCase()
  }
];

export const studioSetNumberOptions = [
  { value: AD_LABEL, displayValue: i18n.t('location:full').toUpperCase() },
  { value: AM_LABEL, displayValue: i18n.t('location:am').toUpperCase() },
  { value: PM_LABEL, displayValue: i18n.t('location:pm').toUpperCase() }
];

export const studioProductionTypeOptions = [
  { value: 'regular', displayValue: i18n.t('location:regular').toUpperCase() },
  { value: 'dblhmu', displayValue: i18n.t('location:dblhmu').toUpperCase() }
];

export const productTierOptions = [
  { value: 0, displayValue: i18n.t('none').toUpperCase() },
  { value: 1, displayValue: '1' },
  { value: 2, displayValue: '2' },
  { value: 3, displayValue: '3' },
  { value: 4, displayValue: '4' },
  { value: 5, displayValue: '5' }
];

export const productTierStyleMap = {
  0: 'productTier0',
  1: 'productTier1',
  2: 'productTier2',
  3: 'productTier3',
  4: 'productTier4',
  5: 'productTier5',
  6: 'productTier6',
  7: 'productTier7'
};

export const employeeBookingTierOptions = [
  { value: 1, displayValue: '1' },
  { value: 2, displayValue: '2' },
  { value: 3, displayValue: '3' },
  { value: 4, displayValue: '4' },
  { value: 5, displayValue: '5' }
];

export const employeeAbilityTierOptions = [
  { value: 0, displayValue: `0 (${i18n.t('userProfile:training')})` },
  ...employeeBookingTierOptions
];

export const multipleWeekOptions = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
]

export const positionAttributeTypeOptions = [
  {
    index: 0,
    type: 'boolean'
  },
  {
    index: 1,
    type: 'string'
  },
  {
    index: 2,
    type: 'site'
  },
  {
    index: 3,
    type: 'image'
  },
  {
    index: 4,
    type: 'date'
  }
];
export const oneDayMs = 24 * 60 * 60 * 1000;

export const backendUrl = '/backend';
export const inventoryUrl = '/inventory';

export const backendRequestBaseParams = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
  withCredentials: true,
}

export const logoProfileUrl =
  'https://via.placeholder.com/300x300/000000/FFFFFF/?text=SSENSE';

export const employeeTypes = [FULLTIME, CONTRACT, FREELANCE];

export const snackbarDuration = 2000;

export const dashboardKeys = {
  location: 'location',
  planned: 'Planned',
  actual: 'Actual'
};

export const PROGRESS_INFO = {
  BOOKING: 'bookingInfo',
  STUDIO: 'studioInfo',
  SET: 'setInfo'
};

export const DATE_PICKER_OPTION = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  CUSTOM: 'custom'
};

export const sampleAvailability = [
  {
    date: '2020-01-01',
    status: BOOKED_AD,
  },
  {
    date: '2020-01-01',
    status: BOOKED_AM_UNAVAILABLE_PM,
  },
  {
    date: '2020-01-01',
    status: BOOKED_PM_UNAVAILABLE_AM,
  },
  {
    date: '2020-01-01',
    status: BOOKED_AM_AVAILABLE_PM,
  },
  {
    date: '2020-01-01',
    status: BOOKED_PM_AVAILABLE_AM,
  },
  {
    date: '2020-01-01',
    status: UNAVAILABLE_AD,
  },
  {
    date: '2020-01-01',
    status: AVAILABLE_AD,
  },
  {
    date: '2020-01-01',
    status: AVAILABLE_AM,
  },
  {
    date: '2020-01-01',
    status: AVAILABLE_PM,
  },
  {
    date: '2020-01-01',
    status: BOOKED_DECLINED,
  },
];

export const sampleChipEmployee = {
  name: i18n.t('sampleEmployeeName'),
  profileImage: 'https://via.placeholder.com/300x300/000000/FFFFFF/?text=SS',
  id: 0,
};

export const LOGIN_TIMEOUT = 10000

export const closetImageHeight = 306;
export const imagePaddingString = `h_${closetImageHeight},w_220,c_lpad`;

export const closetImageThumbnailHeight = 50;
export const imageThumbnail = `h_${closetImageThumbnailHeight},w_100,c_lpad`;

export const studioBookingTimeSymbol = {
  'AM':'\u{1F506}',
  'PM':'\u{1F319}',
  'AD':''
};
